export const LanguageEnum = Object.freeze({
  spanish: 'es',
  english: 'en'
})
